import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { UsersApi } from '@tribuu-api';

/**
 * Shared email-verification resend behavior. Centralizes the API call and the
 * error → user-facing-message mapping so the skeleton banner and the onboarding
 * publish CTA stay in sync (#17).
 */
@Injectable({ providedIn: 'root' })
export class EmailVerificationService {
  private readonly usersApi = inject(UsersApi);

  /**
   * Triggers a resend and returns a single ephemeral feedback message.
   * Always succeeds — the message reflects success or the mapped error code.
   */
  resend(): Observable<string> {
    return this.usersApi.sendEmailConfirm().pipe(
      map(() => 'Correo enviado. Revisa tu bandeja de entrada.'),
      catchError((err: { error?: { code?: string } }) =>
        of(this.mapError(err?.error?.code))
      )
    );
  }

  private mapError(code: string | undefined): string {
    switch (code) {
      case 'VERIFICATION_RESEND_THROTTLED':
        return 'Espera unos minutos antes de volver a intentarlo.';
      case 'VERIFICATION_RESEND_DAILY_CAP':
        return 'Has alcanzado el límite de envíos por hoy.';
      default:
        return 'No se pudo enviar el correo. Intenta de nuevo.';
    }
  }
}
